import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
import { Small } from '@finect/tabular-core/Small';
export var ResultItem = styled.li.withConfig({
  displayName: "ResultItem",
  componentId: "sc-eu0dwa-0"
})(["display:flex;align-items:flex-start;padding:9px 0 0;", ";font-weight:400;", ";", "{flex-shrink:0;line-height:24px;}"], getFont(0), maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    justify-content: space-between;\n  "]))), Small);
export var ResultItemLink = styled.a.withConfig({
  displayName: "ResultItem__ResultItemLink",
  componentId: "sc-eu0dwa-1"
})(["padding-right:6px;color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.linkColor;
});